export type CheckInDateMode = 'hoy' | 'semana' | 'mes' | 'intervalo';

export const toDateStr = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export function getCheckInRange(
  mode: CheckInDateMode,
  custom: { start: string; end: string }
): { start: string; end: string } {
  if (mode === 'intervalo') {
    return { start: custom.start || custom.end, end: custom.end || custom.start };
  }

  const today = new Date();
  const end = toDateStr(today);

  if (mode === 'semana') {
    const start = new Date(today);
    const day = start.getDay();
    const diffToMonday = (day + 6) % 7;
    start.setDate(start.getDate() - diffToMonday);
    return { start: toDateStr(start), end };
  }

  if (mode === 'mes') {
    return { start: toDateStr(new Date(today.getFullYear(), today.getMonth(), 1)), end };
  }

  return { start: end, end };
}
